import { render, staticRenderFns } from "./FieldFiles.vue?vue&type=template&id=204e9750&scoped=true&"
import script from "./FieldFiles.vue?vue&type=script&lang=js&"
export * from "./FieldFiles.vue?vue&type=script&lang=js&"
import style0 from "./FieldFiles.vue?vue&type=style&index=0&id=204e9750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e9750",
  null
  
)

/* custom blocks */
import block0 from "./FieldFiles.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports